import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  createBankAccountSettings,
  getBankAccountSettings,
  updateBankAccountSettings,
} from './BankAccountsSettings.service';
import {
  BankAccountSettingsCreateRequest,
  BankAccountSettingsUpdateRequest,
} from './BankAccountsSettings.types';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';

export function useBankAccountSettings(bankAccountId?: number) {
  const query = useQuery(
    ['bankAccountSettings', bankAccountId],
    () => getBankAccountSettings(bankAccountId),
    {
      enabled: !!bankAccountId,
      onError: (error) => {
        notificationError(error);
      },
    },
  );

  return query;
}

export function useCreateBankAccountSettings() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: BankAccountSettingsCreateRequest) => createBankAccountSettings(obj),
    {
      async onSuccess(_, data) {
        notification.success({
          message: 'Sucesso!',
          description: 'Configuração enviada com sucesso!',
        });

        await queryClient.invalidateQueries([
          'bankAccountSettings',
          data.bankAccountId,
        ]);
      },

      onError: (error) => {
        notificationError(error);
      },
    },
  );

  return mutation;
}

export function useUpdateBankAccountSettings() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: BankAccountSettingsUpdateRequest) => updateBankAccountSettings(obj),
    {
      async onSuccess(_, data) {
        notification.success({
          message: 'Sucesso!',
          description: 'Configuração enviada com sucesso!',
        });

        await queryClient.invalidateQueries([
          'bankAccountSettings',
          data.bankAccountId,
        ]);
      },

      onError: (error) => {
        notificationError(error);
      },
    },
  );

  return mutation;
}
